import { createContext } from 'react';
import { IItemForGetShortInfo, TLanguageIDs, ICreateGameCategory, IGameCategoryTranslation } from 'types';

export type TCreateGameCategoryVisibleForm = 'mainForm' | 'translations';
export type TTypeOfCreateGameCategoryModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'someTranslationIsEmpty';

export interface ICreateGameCategoryState {
	visibleForm: TCreateGameCategoryVisibleForm;
	name: string;
	fetchedLanguages: IItemForGetShortInfo[];
	IDsSelectedLanguages: TLanguageIDs[];
	dataForSubmit: ICreateGameCategory | null;
	typeOfModalWindow: TTypeOfCreateGameCategoryModalWindow;
	selectedTranslationTab: TLanguageIDs | null;
	translations: IGameCategoryTranslation[];
}

export const createGameCategoryInitialState: ICreateGameCategoryState = {
	visibleForm: 'mainForm',
	name: '',
	fetchedLanguages: [],
	IDsSelectedLanguages: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
	selectedTranslationTab: null,
	translations: [],
};

export interface ICreateGameCategoryContext extends ICreateGameCategoryState {
	changeVisibleForm(value: TCreateGameCategoryVisibleForm): void;
	changeName(value: string): void;
	setFetchedLanguages(value: IItemForGetShortInfo[]): void;
	setIDsLanguages(value: TLanguageIDs[]): void;
	setDataForSubmit(data: ICreateGameCategory | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateGameCategoryModalWindow): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	resetFields(): void;
}

export const CreateGameCategoryContext = createContext<ICreateGameCategoryContext>({
	changeVisibleForm: () => undefined,
	changeName: () => undefined,
	setFetchedLanguages: () => undefined,
	setIDsLanguages: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	resetFields: () => undefined,
	...createGameCategoryInitialState,
});
